import { Pipe, PipeTransform } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Pipe({
  name: 'filterSearch'
})
export class FilterSearchPipe implements PipeTransform {

  constructor(private snackBar: MatSnackBar){}

  transform(value: any, searchValue): any {

    if (!searchValue) return value;
    let newArr = value?.filter((v) => v.name.toLowerCase().indexOf(searchValue.toLowerCase()) > -1 )
    if(newArr.length != 0) {
      if(this.snackBar) this.snackBar.dismiss();
      return newArr
    }
    this.snackBar.open("No results found", "Ok", { duration: 5000 })
    return value;
  }

}
